import React, {FC} from 'react';
import {useIntl} from 'react-intl';

import {COLOR, FLEX_DIRECTION, SPACE, Text, useDevice, View} from '@lookiero/aurora';

import {HowItWorks} from './_components/HowItWorks';
import {JoinIn} from '../_components/JoinIn';
import {TEXT} from './ReferralsPending.definition';
import {style} from './ReferralsPending.styles';
import {Section} from '@views/Referrals';
import {ShareButtons, ShareButtonsVariant} from '../_components/ShareButtons/ShareButtons';
import {useReferrals} from '@views/Referrals/_contexts/ReferralsContext';
import {useRafImagePath} from '../hooks/useRafImagePaths';

const ReferralsPending: FC = () => {
  const {screen} = useDevice();
  const {formatMessage} = useIntl();
  const rafImage = useRafImagePath('referral');

  const {
    referralInfo: {referralCode, referralCredit, referredCredit},
  } = useReferrals();

  return (
    <>
      <JoinIn image={rafImage} showImageOnMobile>
        <View>
          <Text heading level={screen.L ? 1 : 2} marginBottom={SPACE.SPACE_2} testID="referral-title">
            {formatMessage(TEXT.CLAIM, {referralCredit, referredCredit})}
          </Text>
          <Text
            level={screen.L ? 2 : 3}
            marginBottom={screen.L ? SPACE.SPACE_8 : SPACE.SPACE_6}
            color={COLOR.TEXT_MEDIUM}
          >
            {formatMessage(TEXT.EXPLANATION, {referralCredit, referredCredit})}
          </Text>
        </View>
        <View
          style={style.buttonContainer}
          flexDirection={screen.L ? FLEX_DIRECTION.ROW : FLEX_DIRECTION.COLUMN}
          marginBottom={screen.L ? undefined : SPACE.SPACE_8}
          testID={'buttonContainer'}
        >
          <ShareButtons
            referredCredit={referredCredit}
            referralCode={referralCode}
            section={Section.REFERRAL_VIEW}
            variant={screen.L ? ShareButtonsVariant.HORIZONTAL : ShareButtonsVariant.VERTICAL}
            testID={'referral-pending'}
          />
        </View>
      </JoinIn>
      <HowItWorks referralCredit={referralCredit} referredCredit={referredCredit} referralCode={referralCode} />
    </>
  );
};

export {ReferralsPending};
